import * as React from 'react';
import clsx from 'clsx';
import axios, { CancelTokenSource } from 'axios';
import { useHistory } from "react-router-dom";
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, Stepper, Step, StepLabel, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutState, CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { CheckState, CheckStateContext } from '../../providers/CheckStateContextProvider';
import { GetCheckTotalResponse } from '../../models/payment/GetCheckTotalResponse';
import { CheckTotal } from '../../models/payment/CheckTotal';
import Shift4Payment, { i4GoSuccessData, Shift4PaymentProps, Shift4SuccessHandler } from './Shift4Payment';
import SplitButtons, { SplitButtonProps } from '../common/Buttons/SplitButtons';
import PaymentLandscapeBar, { PaymentLandscapeBarProps } from './PaymentLandscapeBar';
import { ErrorCode } from '../../models/common/ErrorCode';
import { Tip } from '../../models/payment/Tip';
import { MakePaymentResponse } from '../../models/payment/MakePaymentResponse';
import PaymentTip, { PaymentTipProps } from './PaymentTip';
import CustomStepIcon from '../common/CustomStepIcon';
import { GetCheckTotalRequest } from '../../models/payment/GetCheckTotalRequest';
import { String_PayCheck_PaymentLongTime, String_PayCheck_CheckClosed, String_PayCheck_ProcessingPayment, 
    String_System_GeneralError, String_System_ConnectionError, String_PayCheck_ClaimAmountsChanged, 
    String_PayCheck_BackButton, String_PayCheck_CompleteButton, 
    String_PayCheck_NextButton, String_System_Cancel, String_PayCheck_TotalWithTipLabel, String_PayCheck_ErrorPaymentFailed, 
    String_PayCheck_PaymentExceedsAmountDue, String_PayCheck_Step1Label, String_PayCheck_Step2Label,
    String_System_Ok, String_PayCheck_ErrorCreditCard, String_Check_ServiceChargePopup, String_Check_CheckPaid, String_PayCheck_RoomCharge_GuestCannotChargeError, String_PayCheck_RoomCharge_GuestNotFoundError, String_System_Done, 
    String_PayCheck_ErrorPaymentFailedDeclined,
    String_PayCheck_ErrorPaymentFailedInsufficientFunds,
    String_PayCheck_ErrorPaymentFailedExpiredCard} from '../../utilities/StringHelper';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import Loader from '../common/Loader';
import LoaderLandscapePayment from '../common/LoaderLandscapePayment';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { PaymentMethod } from '../../models/payment/PaymentMethod';
import FullWidthButton, { FullWidthButtonProps, FullWidthButtonSize } from '../common/Buttons/FullWidthButton';
import { GetCurrencyCode } from '../../utilities/CurrencyHelper';
import { encryptCardInfo } from  '../../utilities/PaymentHelper';
import { PaymentDetail } from '../../models/payment/PaymentDetail';
import { MakePaymentRequest } from '../../models/payment/MakePaymentRequest';
import ServiceChargeDialog, { ServiceChargeDialogProps } from './ServiceChargeDialog';
import { InitializePaymentRequest } from '../../models/payment/InitializePaymentRequest';
import { InitializePaymentResponse } from '../../models/payment/InitializePaymentResponse';
import { SplitType } from '../../models/common/SplitType';
import { CheckState as CheckStateEnum } from '../../models/common/CheckState';
import { NavigateCheckOutStart } from '../common/NavigateCheckOutStart';
import DemoPayment from './DemoPayment'
import { CheckOutType } from '../../models/common/CheckOutType';
import { PaymentDigitalWalletType } from '../../models/payment/PaymentDigitalWalletType';
import { PaymentGateway } from '../../models/common/PaymentGateway';
import StripePayment, { StripePaymentProps, StripeErrorHandler, StripeBackClickHandler } from './StripePayment';
import { PaymentGatewayConnector } from '../../models/common/PaymentGatewayConnector';
import SpreedlyPayment, { SpreedlyErrorHandler, SpreedlyPaymentProps, SpreedlyReadyHandler, SpreedlySuccessHandler } from './SpreedlyPayment';
import { TextFieldChangeHandler } from '../common/TextField';
import { ManualTipChangeHandler } from './ManualTipSelector';
import RoomCharge, { RoomChargeCompleteHandler, RoomChargeProps } from './RoomCharge';
import PaymentSelection, { PaymentSelectionProps } from './PaymentSelection';
import GlobalPayPayment, { GlobalPayGooglePaySuccessHandler, GlobalPayPaymentProps, GlobalPayThreeDsDoneHandler, GlobalPayThreeDsErrorHandler, GlobalPayThreeDsOpenHandler } from './GlobalPayPayment';
import FreedomPayPayment, { FreedomPayCreatePaymentCompleteHandler, FreedomPayPaymentProps } from './FreedomPayPayment';
import ParPayPayment, { ParPayErrorHandler, ParPayGooglePaySuccessHandler, ParPayPaymentProps, ParPaySuccessHandler, ParPayValidateHandler } from './ParPayPayment';
import { POSType } from '../../models/common/POSType';
import { PMSType } from '../../models/common/PMSType';
import { GooglePayTokenRaw, SignedKeyRaw, SignedMessageRaw } from '../../models/payment/GooglePayTokenRaw';
import { GooglePayToken } from '../../models/payment/GooglePayToken';
import { FeedbackType } from '../../models/common/FeedbackType';
import { loadDemoCheckTotal } from '../../models/common/DemoData';
import { PaymentMethodsAccepted } from '../../models/payment/PaymentMethodsAccepted';

const useStyles = makeStyles({
    details: {
        width: '100%',
        position: 'absolute',
        top: (ElementDimensions.appBarHeight) + 'px',
        bottom: (ElementDimensions.stepperHeight + ElementDimensions.footerBarHeightPaymentScreen) + 'px',
        left: 0,
        right: 0,
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsGlobalPay: {
        width: '100%',
        position: 'absolute',
        top: (ElementDimensions.appBarHeight) + 'px',
        bottom: (ElementDimensions.footerBarHeightPaymentScreen) + 'px',
        left: 0,
        right: 0,
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsLandscape: {
        position: 'relative',
        top: ElementDimensions.margin10 + 'px',
        bottom: (ElementDimensions.footerBarHeightPaymentScreen + ElementDimensions.stepperHeight - 20) + 'px',
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsStripe: {
        width: '100%',
        position: 'absolute',
        top: (ElementDimensions.appBarHeight) + 'px',
        bottom: '0px',
        left: 0,
        right: 0,
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsLandscapeStripe: {
        position: 'absolute',
        top: ElementDimensions.margin10 + 'px',
        bottom: '0px',
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    errorMessage: {
        color: themePrimary.palette.error.main
    },
    footerButtons: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: (ElementDimensions.footerBarHeightPaymentScreen + ElementDimensions.stepperHeight) + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: '100%',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    footerButtonsGlobalPay: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: (ElementDimensions.footerBarHeightPaymentScreen) + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: '100%',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    footerButtonsLandscape: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 'calc(100vw *.3)',
        height: (ElementDimensions.footerBarHeightPaymentScreen + ElementDimensions.stepperHeight - 20) + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: 'calc(100vw * .7)',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    landscapeGrid: {
        display: 'grid',
        gridTemplateColumns: 'calc(100vw *.3) calc(100vw *.7)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    landscapeGridContainer: {
        display: 'flex',
        height: '100%',
    },
    loadingContainer: {
        margin: ElementDimensions.margin20 + 'px',
        textAlign: 'center',
    },
    processPaymentText: {
        marginTop: '280px',
        textAlign: 'center',
    },
    root: {
        height: '100%',
        color: themePrimary.palette.secondary.dark,
        overflow: 'hidden',
    },
    rootLandscape: {
        marginTop: '0',
    },
    stepper: {
        paddingTop: ElementDimensions.padding5 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    stepsContainer: {
        paddingBottom: ElementDimensions.padding10 + 'px',
        height: '100%',
    },
    tipLabel: {
        fontSize: '1.4rem',
    },
    totalContainer: {
        display: 'flex',
        /*borderTop: '2px solid ' + themePrimary.palette.secondary.dark,
        borderBottom: '2px solid ' + themePrimary.palette.secondary.dark,*/
        textAlign: 'center',
        paddingLeft: ElementDimensions.padding20 + 'px',
        paddingRight: ElementDimensions.padding20 + 'px',
        margin: ElementDimensions.margin10 + 'px',        
        backgroundColor: themePrimary.palette.grey[200],
        borderRadius: '10px',
    },
    totalContainer2: {
        display: 'flex',
        textAlign: 'center',
        paddingLeft: ElementDimensions.padding20 + 'px',
        paddingRight: ElementDimensions.padding20 + 'px',
        borderBottom: props => '2px solid ' + themePrimary.palette.grey[200],
    },
    totalContainer2Show: {
        visibility: 'visible',
    },
    totalContainer2Hide: {
        visibility: 'hidden',
    },
    totalInnerContainer: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    totalText: {
        color: themePrimary.palette.secondary.contrastText,
    },
    totalTextAmount: {
        color: themePrimary.palette.secondary.contrastText,
    },
 });

export default function PayCheck(props: any) {
    const isPortrait = true;
    let history = useHistory();
    const [errorDialogOpen, setErrorDialogOpen] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');
    const [errorDialogTryAgain, setErrorDialogTryAgain] = React.useState<boolean>(true);
    const [loadError, setLoadError] = React.useState<boolean>(false);
    const [checkPaidError, setCheckPaidError] = React.useState<boolean>(false);
    const [paymentExceedsAmountDueError, setPaymentExceedsAmountDueError] = React.useState<boolean>(false);
    const [paymentError, setPaymentError] = React.useState<boolean>(false);
    const [totalChangedError, setTotalChangedError] = React.useState<boolean>(false);
    const [paying, setPaying] = React.useState<boolean>(false);
    const [sendingPayment, setSendingPayment] = React.useState<boolean>(false);
    const [paymentLongTimeError, setPaymentLongTimeError] = React.useState<boolean>(false);
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [total, setTotal] = React.useState<string>('');
    const [tip, setTip] = React.useState<Tip>();
    const [tipValue, setTipValue] = React.useState<number | undefined>(undefined);
    const [checkTotal, setCheckTotal] = React.useState<CheckTotal | null>(null);
    const [activeStep, setActiveStep] = React.useState<number>(0);
    const [paymentMethodAllowed, setPaymentMethodAllowed] = React.useState<PaymentMethodsAccepted | undefined>(undefined);
    const [paymentMethodUsed, setPaymentMethodUsed] = React.useState<PaymentMethod | null>(null);
    const [paymentMethodSelected, setPaymentMethodSelected] = React.useState<boolean>(false);
    const [paymentDigitalWalletType, setPaymentDigitalWalletType] = React.useState<PaymentDigitalWalletType>(PaymentDigitalWalletType.None);
    const [isCardError, setCardIsError] = React.useState<boolean>(false);
    const [enableCompleteButton, setEnableCompleteButton] = React.useState<boolean>(false);
    const [cardNumber, setCardNumber] = React.useState<string>('');
    const [cardExpMonth, setCardExpMonth] = React.useState<string>('');
    const [cardExpYear, setCardExpYear] = React.useState<string>('');
    const [cardCVC, setCardCVC] = React.useState<string>('');
    const [paymentLongTimeTimeoutId, setPaymentLongTimeTimeoutId] = React.useState<any | null>(null);
    const [buttonClickLock, setButtonClickLock] = React.useState<boolean>(false);
    const [i4GoReady, seti4GoReady] = React.useState<boolean>(false);
    const [parPayReady, setParPayReady] = React.useState<boolean>(false);
    const [globalPayThreeDsOpen, setGlobalPayThreeDsOpen] = React.useState<boolean>(false);
    const [globalPayThreeDsDoneButtonClicked, setGlobalPayThreeDsDoneButtonClicked] = React.useState<boolean>(false);
    const [roomCharge, setRoomCharge] = React.useState<boolean>(false);
    const [roomChargePayment, setRoomChargePayment] = React.useState<boolean>(false);
    const [roomChargeLastName, setRoomChargeLastName] = React.useState<string | null>(null);
    const [roomChargeRoomNumber, setRoomChargeRoomNumber] = React.useState<string | null>(null);
    const [spreedlySubmit, setSpreedlySubmit] = React.useState<boolean>(false);
    const [parPaySubmit, setParPaySubmit] = React.useState<boolean>(false);
    const [serviceChargeDialogOpen, setServiceChargeDialogOpen] = React.useState<boolean>(false);
    const [serviceCharge, setServiceCharge] = React.useState<string>('');
    const [initialized, setInitialized] = React.useState<boolean>(false);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });
    const steps = getSteps();
    let loadRetries: number = 0;

    React.useEffect(() => {
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        if (checkOutState.state.checkOutType === CheckOutType.Demo) {
            if (!paying) {
                const newCheckState: CheckState = checkState.state;
                newCheckState.paymentId = null;
                checkState.setState(newCheckState);
    
                initDemoPayment()
            }
        }
        else {
            window.removeEventListener("message", messageHandler);
            window.addEventListener("message", messageHandler);

            if (!initialized) {
                initializePayment(source);
            }
        }        
        
        return () => {
            source.cancel();
            clearTimeout(paymentLongTimeTimeoutId);
            window.removeEventListener("message", messageHandler);
        };
    }, [loaded, paymentLongTimeTimeoutId, paymentLongTimeError, checkPaidError, paymentExceedsAmountDueError, 
        totalChangedError, paying, globalPayThreeDsOpen, globalPayThreeDsDoneButtonClicked]);

    const messageHandler = (event: { data: string; }) => {
        try{
            var data = JSON.parse(event.data);
            if (data.action === "i4GoReady") {
                seti4GoReady(true);
                setButtonClickLock(false);
            }
            else if (data.action === "i4GoFailure") {
                setPaying(false);
                setLoaded(true);
            }            
            else if (data.action === "roomCharge") {
                setRoomCharge(true);
            }
        }
        catch (exception) {

        }
    }

    const initializePayment = (cancelTokenSource: CancelTokenSource) => {
        const request: InitializePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId,
            split_type: checkState.state.splitType,
            split_amount: checkState.state.splitAmount,
            split_percentage: checkState.state.splitPercentage,
            split_evenly_count: checkState.state.splitEvenlyCount,
            unclaimed_amount: checkState.state.checkSummary!!.unclaimed_amount,
        }

        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/initialize"
    
        const headers = {
            'X-API-Key': checkOutState.state.restaurantApiKey,
            'location_id': checkOutState.state.restaurantId
        }
    
        axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
        .then(function(response) {
            let r = response.data as InitializePaymentResponse;

            if (r.success === true) {
                setInitialized(true);

                if (r.check_state === CheckStateEnum.Paid) {
                    setCheckPaidError(true);
                    setErrorDialogTryAgain(false);
                    setErrorMessage(String_Check_CheckPaid.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogOpen(true);
                }
                else {
                    const newCheckState: CheckState = checkState.state;
                    newCheckState.paymentId = r.check_please_payment_id;
                    
                    checkState.setState(newCheckState);

                    getCheckTotal(cancelTokenSource);
                }
            }
            else {
                if (r.error_code === ErrorCode.ClaimAmountsChanged) {
                    setErrorMessage(String_PayCheck_ClaimAmountsChanged.find(s => s.key === userState.state.locale)!!.value);
                    setTotalChangedError(true);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                    setLoadError(true);
                    setLoaded(true);
                }
                else {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(true);
                    setErrorDialogOpen(true);
                    setLoadError(true);
                    setLoaded(true);
                }
            }
        })
        .catch(function(error) {
            if (error.response) {
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
                setLoadError(true);
            }
            else {
                setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
                setLoadError(true);
            }
        });
    };

    const getCheckTotal = (cancelTokenSource: CancelTokenSource) => {
        const request: GetCheckTotalRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
        };

        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/total"
    
        const headers = {
            'X-API-Key': checkOutState.state.restaurantApiKey,
            'location_id': checkOutState.state.restaurantId
        }
    
        axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
        .then(function(response) {
            let r = response.data as GetCheckTotalResponse;

            if (r.success === true) {
                if (r.check_state === CheckStateEnum.Paid) {
                    setCheckPaidError(true);
                    setErrorDialogTryAgain(false);
                    setErrorMessage(String_Check_CheckPaid.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogOpen(true);
                }
                else {
                    setCheckTotal(r.check_total);
                    setPaymentMethodAllowed(r.payment_method);
                    setServiceCharge(r.check_total.check_please_service_charge_string);
                    
                    let defaultTip: Tip | undefined = r.check_total.tips.find(t => t.key === r.check_total.default_tip);
    
                    if (defaultTip !== null && defaultTip !== undefined) {
                        setTip(defaultTip);
                        calculateTotal(parseFloat(r.check_total.amount_due_string_no_currency), parseFloat(defaultTip.value));
                    }
                    else {
                        calculateTotal(parseFloat(r.check_total.amount_due_string_no_currency), 0.0);
                    }
    
                    const state: CheckState = checkState.state;
                    state.checkTotal = r.check_total;
                    checkState.setState(state);
    
                    if (r.show_minimum_tip_popup) {
                        setServiceChargeDialogOpen(true);
                    }
                        
                    setLoaded(true);   
                }
            }
            else {                
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
                setLoadError(true);
                setLoaded(true);
            }
        })
        .catch(function(error) {
            if (error.response) {
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
                setLoadError(true);
            }
            else {
                setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
                setLoadError(true);
            }
        });
    }

    const initDemoPayment = () => {
        var total: CheckTotal = loadDemoCheckTotal()
        setCheckTotal(total);
        setPaymentMethodAllowed(PaymentMethodsAccepted.Visa);
        setServiceCharge(".95");

        let defaultTip: Tip | undefined = total.tips.find(t => t.key === total.default_tip);

        if (defaultTip !== null && defaultTip !== undefined) {
            setTip(defaultTip);
            calculateTotal(parseFloat(total.amount_due_string_no_currency), parseFloat(defaultTip.value));
        }
        else {
            calculateTotal(parseFloat(total.amount_due_string_no_currency), 0.0);
        }
        
        const state: CheckState = checkState.state;
        state.checkTotal = total;
        checkState.setState(state);
  
        setLoaded(true);
    }

    function getSteps() {
        return [String_PayCheck_Step1Label.find(s => s.key === userState.state.locale)!!.value, 
            String_PayCheck_Step2Label.find(s => s.key === userState.state.locale)!!.value];
    }

    const calculateTotal = (currentTotal: number, currentTip: number) => {
        let total = (currentTotal + currentTip);
        let totalString = new Intl.NumberFormat(checkOutState.state.restaurantLocale!!, { style: 'currency', 
            currency: GetCurrencyCode(checkOutState.state.restaurantLocale!!) }).format(total);

        setTotal(totalString);
        
        const state: CheckState = checkState.state;
        state.checkTotalWithTip = totalString;
        state.tip = Math.round(currentTip * 100.00);
        state.tipString = new Intl.NumberFormat(checkOutState.state.restaurantLocale!!, { style: 'currency', 
            currency: GetCurrencyCode(checkOutState.state.restaurantLocale!!) }).format(currentTip);
        checkState.setState(state);
    }

    const handleLeftButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (activeStep == 0) {
            history.goBack()
        }
        else if (activeStep == 1) {
            setTipValue(undefined)
            setPaymentMethodSelected(false)
            setRoomCharge(false);
            seti4GoReady(false);
            calculateTotal(parseFloat(checkTotal!!.amount_due_string_no_currency), 0.0);
            setCardIsError(false);
            setActiveStep(activeStep - 1);
        }
        else {
            setCardIsError(true);
            setActiveStep(activeStep - 1);
        }
    }

    const handleRightButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        moveStepForward(event);
    }

    const moveStepForward = (event: React.MouseEvent<HTMLElement>) => {
        if (activeStep < 1) {
            if (checkTotal!!.minimum_tip) {
                if ((tipValue!! * 100) < checkTotal!!.minimum_tip_amount) {
                    setServiceChargeDialogOpen(true)
                }
                else {
                    setActiveStep(activeStep + 1);
                }
            }
            else {
                setActiveStep(activeStep + 1);
            }
        }
        else if (activeStep === 1) {
            if (checkOutState.state.paymentGateway === PaymentGateway.Demo) {
                setTimeout(() => {makeDemoPayment();}, 3000);
            }
            else if (roomChargePayment) {
                if (roomChargeLastName !== null && roomChargeLastName !== "" &&
                    roomChargeRoomNumber !== null && roomChargeRoomNumber !== "") {
                    setPaying (true)
                    makeRoomChargePayment(roomChargeLastName!!, roomChargeRoomNumber!!)
                }
            }
            else if (checkOutState.state.paymentGateway === PaymentGateway.Shift4) {
                var postDataShift4 = {
                    action: "i4GoSubmit"
                }
                window.postMessage(JSON.stringify(postDataShift4), "*");
            }
            else if (checkOutState.state.paymentGatewayConnector === PaymentGatewayConnector.Spreedly) {
                setSpreedlySubmit(true)
            }
            else if (checkOutState.state.paymentGateway === PaymentGateway.ParPay) {
                var postData = {
                    action: "parPaySubmit"
                }
                window.parent.postMessage(JSON.stringify(postData), "*");
            }
        }
        else {
           if (isCardError) {
                setErrorMessage(String_PayCheck_ErrorCreditCard.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
            }
            else {
                setActiveStep(activeStep + 1);
            }
        }
    }

    const handleTipButtonClick = (event: React.MouseEvent<HTMLElement> | undefined, tipValue: number, isManual: boolean) => {
        if (checkTotal !== null && checkTotal !== undefined && tipValue !== undefined) {
            setTipValue(tipValue);
            calculateTotal(parseFloat(checkTotal.amount_due_string_no_currency), tipValue);
        }
    }

    const handleManualTipChange: ManualTipChangeHandler = (tipValue: number) => {
        if (checkTotal !== null && checkTotal !== undefined && tipValue !== undefined) {
            setTipValue(tipValue);
            calculateTotal(parseFloat(checkTotal.amount_due_string_no_currency), tipValue);
        }
    }

    const paymentTipProps: PaymentTipProps = {
        checkTotal: checkTotal,
        onTipClickHandler: handleTipButtonClick,
        onManualTipChangeHandler: handleManualTipChange
    }

    const mapCardType = (cardType: string): PaymentMethod | null => {
        let paymentMethod: PaymentMethod | null = null;

        switch(cardType.toLowerCase())
        {
            case 'visa':
                paymentMethod = PaymentMethod.Visa;
                break;
            case 'mastercard':
                paymentMethod = PaymentMethod.Mastercard;
                break;
            case 'amex':
                paymentMethod = PaymentMethod.Amex;
                break;
            case 'discover':
                paymentMethod = PaymentMethod.Discover;
                break;
        }

        return paymentMethod;
    }

    const makePayment = async () => {
        setLoaded(false);
        setPaying (true);

        if (checkOutState.state.paymentGateway === PaymentGateway.Stripe) {
            setPaymentLongTimeTimeoutId(setTimeout(() => { setPaymentLongTimeError(true) }, 7000));
        }
        else if (checkOutState.state.paymentGateway === PaymentGateway.Demo) {
            setTimeout(() => {makeDemoPayment();}, 3000);    
        }
    }    

    const makeShift4Payment = async (shift4PaymentDetail: i4GoSuccessData) => {
        if (shift4PaymentDetail !== null && shift4PaymentDetail !== undefined) {
            const paymentDetail: PaymentDetail = {
                tip: checkState.state.tip,
                tax: checkState.state.checkTotal!!.tax,
                sub_total: checkState.state.checkTotal!!.sub_total,
                amount_to_pay: checkState.state.checkTotal!!.amount_due,
                total: checkState.state.checkTotal!!.total,
                zip_code: shift4PaymentDetail.postalCode,
                token: shift4PaymentDetail.token,
                serial_number: '',
                extended_card_data: shift4PaymentDetail.extendedCardData,
                card_number_last_four: '',
                guest_last_name: '',
                room_number: '',
                session_id: ''
            }
    
            const request: MakePaymentRequest = {
                user_id: userState.state.userId!!,
                table_id: checkOutState.state.tableId,
                check_please_payment_id: checkState.state.paymentId!!,
                payment_method: shift4PaymentDetail.paymentMethod,
                payment_digital_wallet_type: shift4PaymentDetail.paymentDigitalWalletType,
                payment_detail: paymentDetail,
                globalpay_hpp_response: null, 
                apple_pay_token: null,
                google_pay_token: null     
            };

            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();

            sendPaymentToServer(request, source);
        }
    }

    const makeParPayPayment = async (token: string) => {
        const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: token,
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: '',
            guest_last_name: '',
            room_number: '',
            session_id: ''
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: null,
            payment_digital_wallet_type: PaymentDigitalWalletType.None,
            payment_detail: paymentDetail,
            globalpay_hpp_response: null,
            apple_pay_token: null,
            google_pay_token: null
        };

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        sendPaymentToServer(request, source);
    }

    const makeParPayGooglePayPayment = async (token: any, paymentMethod: PaymentMethod | null, lastFour: string) => {
        
        const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: token,
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: lastFour,
            guest_last_name: '',
            room_number: '',
            session_id: ''
        }

        var googlePayTokenRaw: GooglePayTokenRaw = JSON.parse(token);
        var signedKeyRaw: SignedKeyRaw =  JSON.parse(googlePayTokenRaw.intermediateSigningKey.signedKey);
        var signedMessageRaw: SignedMessageRaw = JSON.parse(googlePayTokenRaw.signedMessage);

        const googlePayToken: GooglePayToken = {
            encryptedMessage: signedMessageRaw.encryptedMessage,
            ephemeralPublicKey: signedMessageRaw.ephemeralPublicKey,
            tag: signedMessageRaw.tag,
            keyValue: signedKeyRaw.keyValue,
            keyExpiration: signedKeyRaw.keyExpiration,
            signatures: googlePayTokenRaw.intermediateSigningKey.signatures,
            signature: googlePayTokenRaw.signature,
            protocolVersion: googlePayTokenRaw.protocolVersion,
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: paymentMethod,
            payment_digital_wallet_type: PaymentDigitalWalletType.GooglePay,
            payment_detail: paymentDetail,
            globalpay_hpp_response: null,
            apple_pay_token: null,
            google_pay_token: googlePayToken
        };

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        sendPaymentToServer(request, source);
    }

    const makeSpreedlyPayment = async (token: string) => {
        const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: token,
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: '',
            guest_last_name: '',
            room_number: '',
            session_id: ''
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: null,
            payment_digital_wallet_type: PaymentDigitalWalletType.None,
            payment_detail: paymentDetail,
            globalpay_hpp_response: null,
            apple_pay_token: null,
            google_pay_token: null
        };

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        sendPaymentToServer(request, source);
    }

    const makeGlobalPayGooglePayPayment = async (token: any, paymentMethod: PaymentMethod | null, lastFour: string) => {
        const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: token,
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: lastFour,
            guest_last_name: '',
            room_number: '',
            session_id: ''
        }

        var googlePayTokenRaw: GooglePayTokenRaw = JSON.parse(token);
        //var signedKeyRaw: SignedKeyRaw =  JSON.parse(googlePayTokenRaw.intermediateSigningKey.signedKey);
        var signedMessageRaw: SignedMessageRaw = JSON.parse(googlePayTokenRaw.signedMessage);

        const googlePayToken: GooglePayToken = {
            encryptedMessage: signedMessageRaw.encryptedMessage,
            ephemeralPublicKey: signedMessageRaw.ephemeralPublicKey,
            tag: signedMessageRaw.tag,
            keyValue: "",
            keyExpiration: "",
            signatures: [],
            signature: googlePayTokenRaw.signature,
            protocolVersion: googlePayTokenRaw.protocolVersion,
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: paymentMethod,
            payment_digital_wallet_type: PaymentDigitalWalletType.GooglePay,
            payment_detail: paymentDetail,
            globalpay_hpp_response: null,
            apple_pay_token: null,
            google_pay_token: googlePayToken
        };

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        sendPaymentToServer(request, source);
        /*const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: token,
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: lastFour,
            guest_last_name: '',
            room_number: '',
            session_id: ''
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: paymentMethod,
            payment_digital_wallet_type: PaymentDigitalWalletType.GooglePay,
            payment_detail: paymentDetail,
            globalpay_hpp_response: null,
            apple_pay_token: null,
            google_pay_token: null
        };

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        sendPaymentToServer(request, source);*/
    }

    const makeRoomChargePayment = async (lastName: string, roomNumber: string) => {
        const paymentDetail: PaymentDetail = {
            tip: checkState.state.tip,
            tax: checkState.state.checkTotal!!.tax,
            sub_total: checkState.state.checkTotal!!.sub_total,
            amount_to_pay: checkState.state.checkTotal!!.amount_due,
            total: checkState.state.checkTotal!!.total,
            zip_code: '',
            token: '',
            serial_number: '',
            extended_card_data: '',
            card_number_last_four: '',
            guest_last_name: lastName,
            room_number: roomNumber,
            session_id: ''
        }

        const request: MakePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            payment_method: PaymentMethod.RoomCharge,
            payment_digital_wallet_type: PaymentDigitalWalletType.None,
            payment_detail: paymentDetail,
            globalpay_hpp_response: null,
            apple_pay_token: null,
            google_pay_token: null
        };

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        sendPaymentToServer(request, source);
    }

    const makeDemoPayment = async () => {
        
        setLoaded(false);

        const state: CheckState = checkState.state;
        state.checkSummary = null;
        state.checkDetail = null;
        state.checkTotal = null;
        state.paymentId = null;
        state.splitType = SplitType.None;
        state.splitPercentage = 0;
        state.splitAmount = 0;
        state.splitEvenlyCount = 0;
        state.checkTotalWithTip = '';
        state.tip = 0;
        state.tipString = '';
        checkState.setState(state);

        history.push({
            pathname: '/postcheckout/receipt',
        }); 
    }

    const sendPaymentToServer = async (request: MakePaymentRequest, cancelTokenSource: CancelTokenSource) => {
        if (!sendingPayment) {
            setSendingPayment(true);

        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/process"
    
        const headers = {
            'X-API-Key': checkOutState.state.restaurantApiKey,
            'location_id': checkOutState.state.restaurantId
        }
        
        axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
            .then(function(response) {
                let r = response.data as MakePaymentResponse;
                handlePaymentComplete(r);                
            })
            .catch(function(error) {
                clearTimeout(paymentLongTimeTimeoutId);
    
                if (error.response) {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                    setButtonClickLock(false);
                    setLoadError(true);
                    setPaying(false);
                }
                else {
                    setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                    setButtonClickLock(false);
                    setLoadError(true);
                    setPaying(false);
                }
            });
        } 
    }

    const handlePaymentComplete = (r: MakePaymentResponse) => {
        if (r.success === true) {
            setLoaded(false);

            const state: CheckState = checkState.state;
            state.checkSummary = null;
            state.checkDetail = null;
            state.checkTotal = null;
            state.paymentId = null;
            state.splitType = SplitType.None;
            state.splitPercentage = 0;
            state.splitAmount = 0;
            state.splitEvenlyCount = 0;
            state.checkTotalWithTip = '';
            state.tip = 0;
            state.tipString = '';
            checkState.setState(state);

            if (r.restaurant_id != null) {
                const coState: CheckOutState = checkOutState.state;
                coState.restaurantId = r.restaurant_id;
                checkOutState.setState(coState);
            }

            history.push({
                pathname: '/postcheckout/review',
                state: { 
                    paymentId: r.check_please_payment_id,
                }
            });
        }
        else {
            setSpreedlySubmit(false)

            if (r.error_code === ErrorCode.CheckAlreadyPaid) {
                clearTimeout(paymentLongTimeTimeoutId);
                setCheckPaidError(true);
                setLoaded(true);
                setPaying(false);
            }            
            else if (r.error_code === ErrorCode.PaymentFailed)
            {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setPaymentError(true);
            }
            else if (r.error_code === ErrorCode.PaymentFailedDeclined) {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_ErrorPaymentFailedDeclined.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setPaymentError(true);
            }
            else if (r.error_code === ErrorCode.PaymentFailedInsufficientFunds) {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_ErrorPaymentFailedInsufficientFunds.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setPaymentError(true);
            }
            else if (r.error_code === ErrorCode.PaymentFailedExpiredCards) {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_ErrorPaymentFailedExpiredCard.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setPaymentError(true);
            }
            else if (r.error_code === ErrorCode.PaymentAmountExceedsAmountDue)
            {
                clearTimeout(paymentLongTimeTimeoutId);
                setPaymentExceedsAmountDueError(true);
                setErrorMessage(String_PayCheck_PaymentExceedsAmountDue.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
            }
            else if (r.error_code === ErrorCode.Shift4PaymentError) {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_ErrorCreditCard.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setPaymentError(true);
            }
            else if (r.error_code === ErrorCode.GuestNotFound) {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_RoomCharge_GuestNotFoundError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setRoomCharge(true);       
                setRoomChargePayment(false);       
                setRoomChargeLastName(null);       
                setRoomChargeRoomNumber(null);       
            }
            else if (r.error_code === ErrorCode.GuestCannotCharge) {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_PayCheck_RoomCharge_GuestCannotChargeError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
                setRoomCharge(true);
                setRoomChargePayment(false);       
                setRoomChargeLastName(null);       
                setRoomChargeRoomNumber(null);    
            }
            else if (r.error_code === ErrorCode.ParPaymentCompleteNoUpdatedOrder) {
                setLoaded(false);

                const state: CheckState = checkState.state;
                state.checkSummary = null;
                state.checkDetail = null;
                state.checkTotal = null;
                state.paymentId = null;
                state.splitType = SplitType.None;
                state.splitPercentage = 0;
                state.splitAmount = 0;
                state.splitEvenlyCount = 0;
                state.checkTotalWithTip = '';
                state.tip = 0;
                state.tipString = '';
                checkState.setState(state);

                const newCheckOutState: CheckOutState = checkOutState.state;

                newCheckOutState.tableNumber = null;
                newCheckOutState.tableId = null;
                newCheckOutState.restaurantId = null;
                newCheckOutState.restaurantName = null;
                newCheckOutState.restaurantLocale = null;
                newCheckOutState.restaurantCurrency = null;
                newCheckOutState.restaurantCountry = null;
                newCheckOutState.applePayMerchantId = null;
                newCheckOutState.restaurantGooglePayMerchantId = null;
                newCheckOutState.restaurantGooglePayMerchantName = null;
                newCheckOutState.checkOutType = null;
                newCheckOutState.checkInId = null;
                newCheckOutState.sentRating = false;
                newCheckOutState.digitalServiceFee = null;
                newCheckOutState.paymentGateway = PaymentGateway.Demo;
                newCheckOutState.paymentGatewayConnector = PaymentGatewayConnector.None;
                newCheckOutState.posType = null;
                newCheckOutState.pmsType = PMSType.None;
                newCheckOutState.stripeApiKey = null;
                newCheckOutState.stripeAccountId = null;
                newCheckOutState.spreedlyEnvKey = null;
                newCheckOutState.useCaptcha = false;
                newCheckOutState.menuUrl = null;
                newCheckOutState.receiptCheckExternalId = null;
                newCheckOutState.feedbackType = FeedbackType.None;

                checkOutState.setState(newCheckOutState);

                history.replace('../postcheckout/noreceipt');
            }
            else if (r.error_code === ErrorCode.DuplicatePayment) {
                
            }
            else {
                clearTimeout(paymentLongTimeTimeoutId);
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
                setButtonClickLock(false);
                setLoadError(true);
                setLoaded(true);
                setPaying(false);
            }
        }
    }

    const splitButtonProps: SplitButtonProps = {
        leftLabel: activeStep === 0 ? String_System_Cancel.find(s => s.key === userState.state.locale)!!.value : String_PayCheck_BackButton.find(s => s.key === userState.state.locale)!!.value,
        rightLabel: (activeStep === 1) ? String_PayCheck_CompleteButton.find(s => s.key === userState.state.locale)!!.value : String_PayCheck_NextButton.find(s => s.key === userState.state.locale)!!.value,
        leftDisabled: false,
        rightDisabled: disableNextButton(),
        showIcons: false,
        useForwardIcon: activeStep < 2 ? true : false,
        useBackIcon: activeStep > 0 ? true : false,
        onLeftClickHandler: handleLeftButtonClick,
        onRightClickHandler: handleRightButtonClick,
    }

    function disableNextButton(): boolean {
        var disableButton: boolean = false
        if (isCardError) {
            disableButton = true
        }

        if (activeStep === 0) {
            if (tipValue === undefined) {
                disableButton = true
            }
        }
        else if (activeStep === 1) {
            if (roomCharge === true) {
                if (roomChargePayment === false) {
                    disableButton = true
                }
            }
            else {
                if (checkOutState.state.paymentGateway === PaymentGateway.Shift4 && !i4GoReady) {
                    disableButton = true
                }
                else if ((checkOutState.state.paymentGateway === PaymentGateway.Stripe || checkOutState.state.paymentGatewayConnector === PaymentGatewayConnector.Spreedly) && !enableCompleteButton) {
                    disableButton = true
                }
                else if (checkOutState.state.paymentGateway === PaymentGateway.ParPay && !parPayReady) {
                    disableButton = true
                }
            }
        }

        return disableButton
    }

    const paymentLandscapeBarProps: PaymentLandscapeBarProps = {
        total: total,
    }

    const handleShift4Success: Shift4SuccessHandler = (data: i4GoSuccessData) => {
        setCardIsError(false);

        setLoaded(false);
        setPaying (true);

        setPaymentLongTimeTimeoutId(setTimeout(() => { setPaymentLongTimeError(true) }, 7000));
        makeShift4Payment(data);
    }

    const shift4PaymentProps: Shift4PaymentProps = {
        paymentMethodAllowed: paymentMethodAllowed,
        total: (checkState.state.checkTotal === null || checkState.state.checkTotal === undefined) ? 0 : 
            (checkState.state.checkTotal!!.amount_due + checkState.state.tip),
        successHandler: handleShift4Success
    }

    const handleStripeBackClick: StripeBackClickHandler = () => {
        setActiveStep(0);
        setPaying(false);
    }

    const handleStripeError: StripeErrorHandler = () => {
        setActiveStep(0);
        setPaying(false);
    }

    const stripePaymentProps: StripePaymentProps = {
        total: total,
        paymentMethodAllowed: paymentMethodAllowed,
        backHandler: handleStripeBackClick,
        errorHandler: handleStripeError
    }

    const handleSpreedlyReady: SpreedlyReadyHandler = (ready: boolean) => {
        if (ready) {
            setEnableCompleteButton(true);
        }
        else {
            setEnableCompleteButton(false)
        }
    }

    const handleSpreedlySuccess: SpreedlySuccessHandler = (token: string) => {
        setCardIsError(false);

        setLoaded(false);
        setPaying (true);

        setPaymentLongTimeTimeoutId(setTimeout(() => { setPaymentLongTimeError(true) }, 7000));
        makeSpreedlyPayment(token);
    }

    const handleGlobalPayThreeDsOpen: GlobalPayThreeDsOpenHandler = () => {
        setGlobalPayThreeDsOpen(true);
    }

    const handleThreeDsDone: GlobalPayThreeDsDoneHandler = () => {
        setGlobalPayThreeDsOpen(false);
    }

    const handleGlobalPayThreeDsError: GlobalPayThreeDsErrorHandler = () => {
        setGlobalPayThreeDsDoneButtonClicked(false);
    }

    const handleGlobalPayGooglePaySuccess: GlobalPayGooglePaySuccessHandler = (paymentRequest: any) => {
        setCardIsError(false);

        setLoaded(false);
        setPaying (true);

        setPaymentLongTimeTimeoutId(setTimeout(() => { setPaymentLongTimeError(true) }, 7000));

        makeGlobalPayGooglePayPayment(paymentRequest.paymentMethodData.tokenizationData.token, mapCardType(paymentRequest.paymentMethodData.info.cardNetwork), paymentRequest.paymentMethodData.info.cardDetails);
    }

    const globalPayPaymentProps: GlobalPayPaymentProps = {
        paymentMethodAllowed: paymentMethodAllowed,
        total: (checkState.state.checkTotal === null || checkState.state.checkTotal === undefined) ? 0 : 
            (checkState.state.checkTotal!!.amount_due + checkState.state.tip),
        threeDsDoneButtonClicked: globalPayThreeDsDoneButtonClicked,
        threeDsOpenHandler: handleGlobalPayThreeDsOpen,
        threeDsDoneHandler: handleThreeDsDone,
        threeDsErrorHandler: handleGlobalPayThreeDsError,
        googlePaySuccessHandler: handleGlobalPayGooglePaySuccess
    }

    const handleFreedomPayCreatePaymentComplete: FreedomPayCreatePaymentCompleteHandler = (isError: boolean, errorCode?: ErrorCode, errorResponse?: string) => {
        setLoaded(true);

        if (isError) {
            setActiveStep(activeStep - 1)
            if (errorCode !== undefined) {
                
                if (errorCode === ErrorCode.CheckAlreadyPaid) {
                    setCheckPaidError(true);
                    setErrorDialogTryAgain(false);
                    setErrorMessage(String_Check_CheckPaid.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogOpen(true);
                }            
                else if (errorCode === ErrorCode.PaymentFailed)
                {
                    setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                    setPaymentError(true);
                }
                else if (errorCode === ErrorCode.PaymentAmountExceedsAmountDue)
                {
                    setPaymentExceedsAmountDueError(true);
                    setErrorMessage(String_PayCheck_PaymentExceedsAmountDue.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                }
            }
            else if (errorResponse !== undefined) {
                setErrorMessage(errorResponse);
                setErrorDialogTryAgain(false);
                setErrorDialogOpen(true);
            }
        }
    }

    const freedomPayPaymentProps: FreedomPayPaymentProps = {
        paymentMethodAllowed: paymentMethodAllowed,
        total: (checkState.state.checkTotal === null || checkState.state.checkTotal === undefined) ? 0 : 
            (checkState.state.checkTotal!!.amount_due + checkState.state.tip),
        createPaymentCompleteHandler: handleFreedomPayCreatePaymentComplete
    }

    const handleSpreedlyError: SpreedlyErrorHandler = () => {
        setSpreedlySubmit(false)
    }

    const spreedlyPaymentProps: SpreedlyPaymentProps = {
        paymentMethodAllowed: paymentMethodAllowed,
        total: (checkState.state.checkTotal === null || checkState.state.checkTotal === undefined) ? 0 : 
            (checkState.state.checkTotal!!.amount_due + checkState.state.tip),
        submitPayment: spreedlySubmit,
        successHandler: handleSpreedlySuccess,
        readyHandler: handleSpreedlyReady,
        errorHandler: handleSpreedlyError,
        googlePaySuccessHandler: handleGlobalPayGooglePaySuccess,
    }

    const handleParPaySuccess: ParPaySuccessHandler = (token: string) => {
        setCardIsError(false);

        setLoaded(false);
        setPaying (true);

        setPaymentLongTimeTimeoutId(setTimeout(() => { setPaymentLongTimeError(true) }, 7000));
        makeParPayPayment(token);
    }

    const handleParPayGooglePaySuccess: ParPayGooglePaySuccessHandler = (paymentRequest: any) => {
        console.log(paymentRequest);

        setCardIsError(false);

        setLoaded(false);
        setPaying (true);

        setPaymentLongTimeTimeoutId(setTimeout(() => { setPaymentLongTimeError(true) }, 7000));
        makeParPayGooglePayPayment(paymentRequest.paymentMethodData.tokenizationData.token, mapCardType(paymentRequest.paymentMethodData.info.cardNetwork), paymentRequest.paymentMethodData.info.cardDetails);
    }

    const handleParPayError: ParPayErrorHandler = () => {
        setParPayReady(false)  
    }

    const handleParPayValidate: ParPayValidateHandler = (success: boolean) => {
        setParPayReady(success)
    }

    const parPayPaymentProps: ParPayPaymentProps = {
        paymentMethodAllowed: paymentMethodAllowed,
        total: (checkState.state.checkTotal === null || checkState.state.checkTotal === undefined) ? 0 : 
            (checkState.state.checkTotal!!.amount_due + checkState.state.tip),
        validateHandler: handleParPayValidate,
        successHandler: handleParPaySuccess,
        errorHandler: handleParPayError,
        googlePaySuccessHandler: handleParPayGooglePaySuccess,
    }

    const handleRoomChargeComplete: RoomChargeCompleteHandler = (lastName: string, roomNumber: string) => {
        setRoomChargeLastName(lastName)
        setRoomChargeRoomNumber(roomNumber)

        if (lastName !== "" && roomNumber !== "") {
            setRoomChargePayment(true)
        }
        else {
            setRoomChargePayment(false)
        }
    }

    const roomChargeProps: RoomChargeProps = {
        onCompleteHandler: handleRoomChargeComplete,
    }

    const handleCheckClosedOkButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        history.push('/website');
    }
    
    const checkClosedButtonProps: FullWidthButtonProps = {
        disabled: false,
        label: String_System_Ok.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: handleCheckClosedOkButtonClick,
    }

    const soloBackButtonOkButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (globalPayThreeDsOpen) {
            setGlobalPayThreeDsDoneButtonClicked(true)
        }
        else {
            setTipValue(undefined)
            setPaymentMethodSelected(false)
            setRoomCharge(false);
            seti4GoReady(false);
            calculateTotal(parseFloat(checkTotal!!.amount_due_string_no_currency), 0.0);
            setCardIsError(false);
            setActiveStep(activeStep - 1);
        }
    }
    
    const soloBackButtonProps: FullWidthButtonProps = {
        disabled: false,
        label: globalPayThreeDsOpen === false ? String_PayCheck_BackButton.find(s => s.key === userState.state.locale)!!.value : String_System_Done.find(s => s.key === userState.state.locale)!!.value,
        alternateColor: false,
        size: FullWidthButtonSize.Large,
        onClickHandler: soloBackButtonOkButtonClick,
    }

    const handleErrorDialogClose = (event: React.MouseEvent<HTMLElement>) => {
        setErrorDialogOpen(false);
        setLoaded(true);
        setLoadError(false);
        
        if (paymentExceedsAmountDueError) {
            history.push('/checkout/check');
        }
        else if (totalChangedError) {
            if (checkOutState.state.posType === POSType.Clear) {
                history.push(checkOutState.state.checkInUrl!!.substring(checkOutState.state.checkInUrl!!.indexOf("checkout") - 1, checkOutState.state.checkInUrl!!.length))
            }
            else {
                history.goBack();
            }
        }
        else if (checkTotal === null || checkTotal === undefined) {
            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();
            initializePayment(source);
        }
        else if (checkPaidError) {
            NavigateCheckOutStart();
        }
        else if (paymentError) {
            history.goBack();
        }
    }

    const errorDialogProps: ErrorDialogProps = {
        open: errorDialogOpen,
        message: errorMessage,
        tryAgain: errorDialogTryAgain,
        onCloseHandler: handleErrorDialogClose,
    }

    const handleServiceChargeDialogCloseClick = (event: React.MouseEvent<HTMLElement>) => {
        setServiceChargeDialogOpen(false);
    }

    const serviceChargeDialogProps: ServiceChargeDialogProps = {
        message: String_Check_ServiceChargePopup(checkOutState.state.restaurantName!!,
            (checkTotal !== null && checkTotal !== undefined) ? checkTotal!!.minimum_tip.toString() : "").find(s => s.key === userState.state.locale)!!.value,
        open: serviceChargeDialogOpen,
        onCloseHandler: handleServiceChargeDialogCloseClick,
    }

    const onDemoPaymentButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => {
        setPaying(true);
        setTimeout(() => {makeDemoPayment();}, 3000);
    }

    const onPaymentSelectionCompleteHandler = (roomCharge: boolean) => {
        setRoomCharge(roomCharge)
        setPaymentMethodSelected(true)
    }

    const paymentSelectionProps: PaymentSelectionProps = {
        onCompleteHandler: onPaymentSelectionCompleteHandler,
    }

    return (
        <div className={classes.root}>

            {((!loaded && !loadError) || (paying)) && 
                <div>
                    <div className={classes.loadingContainer}>
                        
                        {(!loaded || paying) && isPortrait &&
                            <Loader />                    
                        }

                        {(!loaded || paying) && !isPortrait &&
                            <LoaderLandscapePayment isFullScreen={true}/>                          
                        }
                    </div>

                    {(paying === true && paymentLongTimeError === false) &&
                        <Typography variant="h6" className={classes.processPaymentText}>
                            {String_PayCheck_ProcessingPayment.find(s => s.key === userState.state.locale)!!.value}
                        </Typography>
                    }

                    {(paying === true && paymentLongTimeError === true) &&
                        <Typography variant="h6" className={classes.processPaymentText}>
                            {String_PayCheck_PaymentLongTime.find(s => s.key === userState.state.locale)!!.value}
                        </Typography>
                    }
                </div>
            }

            {loaded && !loadError && checkPaidError && !paying &&
                <div>
                    <Typography variant="h6" className={classes.processPaymentText}>
                        {String_PayCheck_CheckClosed.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                    <div className={classes.footerButtons}>
                        <FullWidthButton 
                            disabled={checkClosedButtonProps.disabled}
                            label={checkClosedButtonProps.label}
                            alternateColor={checkClosedButtonProps.alternateColor}
                            size={checkClosedButtonProps.size}
                            onClickHandler={checkClosedButtonProps.onClickHandler}/>
                    </div>
                </div>
            }

            {(loaded && !loadError && !checkPaidError && checkTotal != null && !paying && isPortrait) &&
                <div>
                    <div className={clsx({
                        [classes.detailsGlobalPay]: checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && activeStep === 1,
                        [classes.detailsStripe]: checkOutState.state.paymentGateway === PaymentGateway.Stripe && activeStep === 1,
                        [classes.details]: !(checkOutState.state.paymentGateway === PaymentGateway.Stripe && activeStep === 1)           
                    })}>
                        <div className={classes.stepsContainer}>
                            {activeStep !== 0 && !(activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.Stripe) &&
                                <div className={clsx(classes.totalContainer2, classes.totalContainer2Show)}>
                                    <div className={classes.totalInnerContainer}>
                                        <Typography variant="h6" className={classes.totalText}>
                                            {String_PayCheck_TotalWithTipLabel.find(s => s.key === userState.state.locale)!!.value}
                                        </Typography>

                                        <Typography variant="h5" className={classes.totalTextAmount}>
                                            {total}
                                        </Typography>
                                    </div>
                                </div>
                            }

                            {(activeStep === 0 && checkTotal != null) &&
                                <PaymentTip 
                                    checkTotal={paymentTipProps.checkTotal}
                                    onTipClickHandler={paymentTipProps.onTipClickHandler}
                                    onManualTipChangeHandler={paymentTipProps.onManualTipChangeHandler} />    
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.Shift4 && !roomCharge &&
                                <Shift4Payment 
                                    paymentMethodAllowed={shift4PaymentProps.paymentMethodAllowed}
                                    total={shift4PaymentProps.total}
                                    successHandler={shift4PaymentProps.successHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && !roomCharge &&
                                <GlobalPayPayment 
                                    paymentMethodAllowed={globalPayPaymentProps.paymentMethodAllowed}
                                    total={globalPayPaymentProps.total}
                                    threeDsDoneButtonClicked={globalPayPaymentProps.threeDsDoneButtonClicked}
                                    threeDsOpenHandler={globalPayPaymentProps.threeDsOpenHandler}
                                    threeDsDoneHandler={globalPayPaymentProps.threeDsDoneHandler}
                                    threeDsErrorHandler={globalPayPaymentProps.threeDsErrorHandler}
                                    googlePaySuccessHandler={globalPayPaymentProps.googlePaySuccessHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.FreedomPay && !roomCharge &&
                                <FreedomPayPayment 
                                    paymentMethodAllowed={freedomPayPaymentProps.paymentMethodAllowed}
                                    total={freedomPayPaymentProps.total}
                                    createPaymentCompleteHandler={freedomPayPaymentProps.createPaymentCompleteHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.Stripe && !roomCharge &&
                                <StripePayment 
                                    total={stripePaymentProps.total}
                                    paymentMethodAllowed={stripePaymentProps.paymentMethodAllowed}
                                    backHandler={stripePaymentProps.backHandler}
                                    errorHandler={stripePaymentProps.errorHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGatewayConnector === PaymentGatewayConnector.Spreedly && !roomCharge &&
                                <SpreedlyPayment 
                                    paymentMethodAllowed={spreedlyPaymentProps.paymentMethodAllowed}
                                    total={spreedlyPaymentProps.total}
                                    submitPayment={spreedlyPaymentProps.submitPayment}
                                    successHandler={spreedlyPaymentProps.successHandler}
                                    readyHandler={spreedlyPaymentProps.readyHandler}
                                    errorHandler={spreedlyPaymentProps.errorHandler} 
                                    googlePaySuccessHandler={spreedlyPaymentProps.googlePaySuccessHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.ParPay && !roomCharge &&
                                <ParPayPayment 
                                    paymentMethodAllowed={parPayPaymentProps.paymentMethodAllowed}
                                    total={parPayPaymentProps.total}
                                    validateHandler={parPayPaymentProps.validateHandler}
                                    successHandler={parPayPaymentProps.successHandler}
                                    errorHandler={parPayPaymentProps.errorHandler}
                                    googlePaySuccessHandler={parPayPaymentProps.googlePaySuccessHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.Stripe && !paymentMethodSelected &&
                                <PaymentSelection 
                                    onCompleteHandler={paymentSelectionProps.onCompleteHandler} />
                            }

                            {activeStep === 1 && roomCharge &&
                                <RoomCharge 
                                    onCompleteHandler={roomChargeProps.onCompleteHandler} />
                            }

                            {activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.Demo &&
                                <DemoPayment 
                                    onClickHandler={onDemoPaymentButtonClickHandler} />
                            }

                            {activeStep === 0 && 
                                <div className={classes.totalContainer}>
                                    <div className={classes.totalInnerContainer}>
                                        <Typography variant="h6" className={classes.totalText}>
                                            {String_PayCheck_TotalWithTipLabel.find(s => s.key === userState.state.locale)!!.value}
                                        </Typography>

                                        <Typography variant="h5" className={classes.totalTextAmount}>
                                            {total}
                                        </Typography>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    {!paying && !(activeStep === 1 && checkOutState.state.paymentGateway === PaymentGateway.Stripe) &&
                        <div className={clsx({
                            [classes.footerButtonsGlobalPay]: checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && activeStep === 1,
                            [classes.footerButtons]: !(checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && activeStep === 1),
                        })}>
                            {isPortrait && !(checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && activeStep === 1) &&
                                <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
                                    {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
                                    </Step>
                                    ))}
                                </Stepper>
                            }
                            
                            {checkOutState.state.paymentGateway !== PaymentGateway.GlobalPay &&
                                <SplitButtons
                                    leftLabel={splitButtonProps.leftLabel}
                                    rightLabel={splitButtonProps.rightLabel}
                                    leftDisabled={splitButtonProps.leftDisabled}
                                    rightDisabled={splitButtonProps.rightDisabled}
                                    showIcons={splitButtonProps.showIcons}
                                    useForwardIcon={splitButtonProps.useForwardIcon}
                                    useBackIcon={splitButtonProps.useBackIcon}
                                    onLeftClickHandler={splitButtonProps.onLeftClickHandler}
                                    onRightClickHandler={splitButtonProps.onRightClickHandler} />
                            }

                            {checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && activeStep === 0 &&
                                <SplitButtons
                                    leftLabel={splitButtonProps.leftLabel}
                                    rightLabel={splitButtonProps.rightLabel}
                                    leftDisabled={splitButtonProps.leftDisabled}
                                    rightDisabled={splitButtonProps.rightDisabled}
                                    showIcons={splitButtonProps.showIcons}
                                    useForwardIcon={splitButtonProps.useForwardIcon}
                                    useBackIcon={splitButtonProps.useBackIcon}
                                    onLeftClickHandler={splitButtonProps.onLeftClickHandler}
                                    onRightClickHandler={splitButtonProps.onRightClickHandler} />
                            }

                            {checkOutState.state.paymentGateway === PaymentGateway.GlobalPay && activeStep === 1 &&
                                <FullWidthButton 
                                    disabled={soloBackButtonProps.disabled}
                                    label={soloBackButtonProps.label}
                                    alternateColor={soloBackButtonProps.alternateColor}
                                    size={soloBackButtonProps.size}
                                    onClickHandler={soloBackButtonProps.onClickHandler}/>
                            }
                            
                        </div>
                    }
                </div>
            }

            <ServiceChargeDialog 
                message={serviceChargeDialogProps.message}
                open={serviceChargeDialogProps.open}
                onCloseHandler={serviceChargeDialogProps.onCloseHandler} />

            <ErrorDialog 
                open={errorDialogProps.open}
                message={errorDialogProps.message}
                tryAgain={errorDialogProps.tryAgain}
                onCloseHandler={errorDialogProps.onCloseHandler} />
        </div>
    );
}
